function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import * as PropTypes from 'prop-types';
import { Constants, OfferType } from '@shared/utils/constants';
import { isTransactApp, isAvailableInThisRegion } from '@shared/utils/appUtils';
export const getDataBiView = ({ linkedAddIns, linkedSaaS })=>{
    let dataBiView = '';
    if ((linkedAddIns === null || linkedAddIns === void 0 ? void 0 : linkedAddIns.length) > 0) {
        dataBiView = Constants.Telemetry.TemplateName.SaaSBundle;
    } else if (linkedSaaS) {
        dataBiView = Constants.Telemetry.AreaName.BundleAddIn;
    }
    return dataBiView;
};
export const getDataBiType = ({ app, billingCountryCode })=>{
    const { ctaTypes = [] } = app;
    return app.offerType === OfferType.SaaSApp ? isTransactApp({
        isEmbedded: false,
        ctaTypes,
        appData: app,
        billingRegion: billingCountryCode
    }) ? Constants.JsllSaas.SaasTransactable : Constants.JsllSaas.SaasNonTransactable : '';
};
export const BaseCtaButton = ({ app, startingPrice, isLoadingUserData, billingCountryCode, CtaComponent, ctaType })=>{
    const newProp = {
        disabled: !isAvailableInThisRegion({
            startingPrice
        }) || isLoadingUserData,
        'data-bi-id': Constants.JsllCTAId[Constants.CTAType[`${ctaType}`]],
        'data-bi-name': app.entityId,
        'data-bi-type': getDataBiType({
            app,
            billingCountryCode
        }),
        'data-bi-area': Constants.Telemetry.AreaName.AppDetails,
        'data-bi-view': getDataBiView(app)
    };
    const ClonedElementWithMoreProps = /*#__PURE__*/ React.cloneElement(CtaComponent, _object_spread({}, newProp));
    return ClonedElementWithMoreProps;
};
BaseCtaButton.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
